import { PaddingValues } from './types';

export const PADDING_KEYS: Array<keyof PaddingValues> = [
  'paddingTop',
  'paddingBottom',
  'paddingLeft',
  'paddingRight',
];
